import { z } from 'zod';

const addressSchema = z.object({
  apartment: z.string().optional(),
  street: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  country: z.string().optional(),
});

export const parentFormSchema = z.object({
  firstName: z
    .string({
      message: 'First name is required',
    })
    .min(2, 'First name must be at least 2 characters'),
  lastName: z
    .string({
      message: 'Last name is required',
    })
    .min(2, 'Last name must be at least 2 characters'),
  email: z
    .string({
      message: 'Email is required',
    })
    .email('Invalid email address'),
  relation: z.string({ message: 'Relation is required' }).min(1),
  primaryPhone: z
    .string({
      message: 'Phone number is required',
    })
    .min(10, 'Phone number must be at least 10 digits'),
  address: addressSchema,
  familyName: z.string().optional(),
});

export type ParentFormValues = z.infer<typeof parentFormSchema>;
